import type { FormConfig } from '../types';
import coverSheet from '../pages/invite/coverSheet';

const formConfig: FormConfig = {
  live: false,
  id: 'invite',
  formName: 'Invite Placeholder Form',
  title: 'Invite Placeholder Form',
  subTitle: 'Summary page',
  showSections: true,
  approval: 'optional',
  sections: [
    {
      title: 'Main Section',
      slug: 'main-section',
      subsections: [
        {
          title: 'Cover Sheet',
          slug: 'cover-sheet',
          pages: coverSheet,
        },
      ],
    },
  ],
};

export default formConfig;
